const WAITING_TIME = {
  noWaiting: 0,
  minWaitingTime: 2000,
  maxWaitingTime: 30000,
};

export default WAITING_TIME;
